import * as utils from './bellplus-utils';
import axios from 'axios';
import { ENV } from '../constants/Constants';
import { logoutApp } from '../services/logout.service';

export const logException = (
	httpMethod: string,
	apiUrl: string,
	requestBody: any,
	exceptionLog: any,
) => {
	const user = utils.getData('userDetails').data;
	const requestObject: any = {
		userId: user.id,
		username: user.username,
		token: user.token,
		httpMethod: httpMethod,
		apiUrl: apiUrl,
		requestBody: JSON.stringify(requestBody),
		exceptionLog: JSON.stringify(exceptionLog),
	};
	exceptionService(ENV.dev.exception, requestObject);
};
export const exceptionService = async (url: any, obj: any) => {
	const headers = await utils.getHeaders();

	return new Promise((resolve, reject) => {
		axios
			.create({
				baseURL: ENV.dev.globalUrl,
				headers: headers,
			})
			.post(url, obj)
			.then((response) => {
				return resolve(response);
			})
			.catch((err) => {
				if (err?.response?.status === 401) {
					logoutApp();
				}

				let response: any = {};
				response = err.response;

				let errorMessage: any = '';
				if (response && response.data) {
					if (response.data.errors && response.data.errors.length) {
						errorMessage = response.data.errors[0];
					}
				}
				return reject(errorMessage);
			});
	});
};
